import { render, staticRenderFns } from "./Rules20251208.vue?vue&type=template&id=338fac4c&"
import script from "./Rules20251208.vue?vue&type=script&lang=js&"
export * from "./Rules20251208.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports